module.exports = __webpack_public_path__ + "static/img/wealth_level_55.4f77ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_55.png
// module id = swRs
// module chunks = 0